export const siteConfig = {
  name: "ContiGO Freeze Foods",
  tagline: "Freeze-dried ingredients for brands thinking ahead.",
  baseUrl:
    import.meta.env?.VITE_SITE_BASE_URL ||
    globalThis.process?.env?.VITE_SITE_BASE_URL ||
    "https://contigofreezefoods.com",
  defaultImage: "/images/premium-powders.jpg",
  whatsappNumber: "919099982088",
  whatsappMessage:
    "Hello ContiGO Freeze Foods, I would like to inquire about freeze-dried ingredients.",
  locale: "en_US"
};

const defaultKeywords = [
  "freeze dried ingredients",
  "freeze dried fruits India",
  "freeze dried vegetables",
  "botanicals",
  "tea cuts",
  "functional food ingredients",
  "ingredient sourcing India",
  "clean label ingredients"
];

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: siteConfig.name,
  url: siteConfig.baseUrl,
  description: siteConfig.tagline,
  areaServed: "Worldwide",
  knowsAbout: [
    "Freeze drying",
    "Food ingredient sourcing",
    "Botanicals",
    "Functional foods",
    "Tea cuts"
  ]
};

export const seoByPath = {
  "/": {
    title: "ContiGO Freeze Foods | Freeze-Dried Ingredients from India",
    description:
      "Premium freeze-dried fruits, vegetables, botanicals, tea cuts and functional ingredients from India for global food, wellness and beverage brands.",
    keywords: defaultKeywords,
    image: "/images/premium-powders.jpg",
    schema: organizationSchema
  },
  "/about": {
    title: "About ContiGO Freeze Foods | Smarter Food Preservation",
    description:
      "Learn how ContiGO Freeze Foods is building a modern freeze-dried ingredient ecosystem rooted in India's agricultural diversity.",
    keywords: [
      "about ContiGO Freeze Foods",
      "freeze dried food company India",
      "food preservation",
      "ingredient ecosystem",
      "export focused ingredients"
    ],
    image: "/images/premium-herbal-tea.jpg"
  },
  "/products": {
    title: "Product Ecosystem | Freeze-Dried Fruits, Vegetables, Botanicals",
    description:
      "Explore premium ingredient categories including freeze-dried fruits, vegetables, herbs, botanicals, tea cuts, powders and blends.",
    keywords: [
      "freeze dried fruits",
      "freeze dried vegetables",
      "herbs and botanicals",
      "tea cuts",
      "functional powders",
      "ingredient formats"
    ],
    image: "/images/category-freeze-dried-fruits.jpg"
  },
  "/applications": {
    title: "Applications & Industries | Modern Food Ecosystems",
    description:
      "Freeze-dried ingredient applications for tea, wellness, nutraceuticals, functional foods, healthy snacks and industrial food businesses.",
    keywords: [
      "freeze dried ingredient applications",
      "tea wellness ingredients",
      "nutraceutical ingredients",
      "functional food",
      "healthy snack ingredients"
    ],
    image: "/images/premium-fruit-bowl.jpg"
  },
  "/export-sourcing": {
    title: "Export & Sourcing | Freeze-Dried Ingredient Sourcing from India",
    description:
      "Export-focused sourcing systems for global importers, ingredient distributors and wellness brands seeking reliable freeze-dried ingredients from India.",
    keywords: [
      "freeze dried ingredient export",
      "ingredient sourcing India",
      "global ingredient importers",
      "food ingredient distributor",
      "private label ingredient sourcing"
    ],
    image: "/images/premium-powders.jpg"
  },
  "/contact": {
    title: "Contact ContiGO Freeze Foods | Request Catalog or Inquiry",
    description:
      "Start a conversation with ContiGO Freeze Foods for freeze-dried ingredients, tea cuts, botanicals and functional food applications.",
    keywords: [
      "request freeze dried catalog",
      "freeze dried ingredient inquiry",
      "ContiGO Freeze Foods contact",
      "botanical ingredient inquiry"
    ],
    image: "/images/category-tea-cuts.jpg"
  }
};

export function normalizePath(pathname = "/") {
  if (!pathname || pathname === "") return "/";
  const withoutHash = pathname.split("#")[0].split("?")[0];
  if (withoutHash === "/") return "/";
  return withoutHash.replace(/\/$/, "");
}

export function absoluteUrl(path = "/") {
  if (path.startsWith("http")) return path;
  return `${siteConfig.baseUrl}${path.startsWith("/") ? path : `/${path}`}`;
}

export function getSeoForPath(pathname) {
  const path = normalizePath(pathname);
  const seo = seoByPath[path] || seoByPath["/"];
  return {
    ...seo,
    path,
    canonical: absoluteUrl(path),
    imageUrl: absoluteUrl(seo.image || siteConfig.defaultImage),
    keywordsText: Array.isArray(seo.keywords) ? seo.keywords.join(", ") : seo.keywords
  };
}
